import { NextPage } from 'next'

import { Page } from 'src/components/layouts/Page'
import { AdminViewPlantingPhotos } from 'src/components/organisms/AdminViewPlantingPhotos'

import { withAdvisorRequired } from 'src/utils/auth'

const ViewPlantingPhotosPage: NextPage = () => {
  return (
    <Page title='Planting Photos | Admin'>
      <AdminViewPlantingPhotos />
    </Page>
  )
}

export default withAdvisorRequired(ViewPlantingPhotosPage)
